angular.module('iqxCore')
.controller('actionDialogDepartmentQuestionsCtrl', function ($scope, FormSvc, QuestionnaireSvc) {

	$scope.showDepartments=function(){
		FormSvc.setOptions($scope,{
			fetchAPI:'callresult/NetOwnerRegistrations?pCandidateID='+$scope.actiondialogparams.linkID,
			multiRow:true,
			fetchTarget:'departments'
		})
		$scope.departmentSelected=false
		$scope.department={}

		return $scope.fetch()
	}

	$scope.viewQuestions=function(department){
		$scope.department=department
		$scope.departmentSelected=true

	    FormSvc.setOptions($scope,{
		    fetchAPI:'callresult/NetOwnerRegistration?pDepartmentID='+$scope.department.DepartmentID+'&pCandidateID='+$scope.actiondialogparams.linkID,
		    saveAPI:'',
		    savePrefix:'p',
		    booleanFields:['temp','perm'],
		    primaryKey:'personid',
		    autoEdit:false,
		    saveCleanFields:true,
		    questionnaire:{
		      tagTarget:'tags',
		      tagLocation:'A'+$scope.department.DepartmentID,
		      id:$scope.actiondialogparams.linkID,
		      postVar:'qanswers',
          displayGroup:'?CANDDEPT_'+$scope.department.DepartmentID
		    }
	    })

	    return $scope.fetch()
	}

	$scope.showDepartments()
})